import initHpSlider from './modules/initHpSlider';
import customSelect from "custom-select";
import magic from './modules/magic';
import Accordion from './modules/hpAccordion';
import textSlider from './modules/textSlider';
import imgTextSlider from './modules/imgTextSlider';
import treeSlider from './modules/treeSlider';
import treeKeySlider from './modules/treeKeySlider';
import treeCollapser from './modules/treeCollapser';
import footer from './modules/footer';
import fourColSlider from './modules/fourColSlider';
import initBackToTop from './modules/backToTop';
import SocialShare from './modules/toggleSocialShare'; 
import youtubeVideoPopin from './modules/youtubeVideoPopin';
import podcastPlayer from './modules/podcastPlayer';
import collapser from './modules/collapser';
import initSearchBar from './cpSearch';
import openVideo from './modules/openVideo';
import reboundSlider from './modules/reboundSlider';
import storiesSlider from './modules/storiesSlider';
import mobilizersSlider from './modules/mobilizersSlider';
import mobilizersFilters from './modules/mobilizersFilters';
import initContactForm from './cpContactForm';
import keyNumberSlider from './modules/keyNumberSlider'
import breadcrumb from './modules/breadcrumb';
import { Header } from './modules/Header';
import { teqAnimations } from './modules/animations';
import hideSocial from './modules/hideSocial';
import initCpCollapser from './modules/initCollapser';
import treeColsMultiLines from './modules/treeColsMultiLines';

document.addEventListener('DOMContentLoaded', () => {
    teqAnimations();

    new Header();
    new openVideo();
    new youtubeVideoPopin();
    new initHpSlider();
    new magic();
    new Accordion();
    new textSlider();
    new imgTextSlider(); 
    new fourColSlider();
    new initBackToTop();
    new SocialShare();
    new podcastPlayer();
    new collapser();
    new reboundSlider();
    new initSearchBar();
    new storiesSlider();
    new treeSlider();
    new treeKeySlider();
    new treeCollapser();
    new footer();
    new mobilizersSlider();
    new mobilizersFilters();
    new keyNumberSlider();

    initContactForm();
    new breadcrumb();
    new hideSocial();
    initCpCollapser();
    treeColsMultiLines();

    customSelect(document.querySelectorAll(".js-select"));
});